import React, { useRef, useEffect } from "react";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";
import "./Contact.css";
import contactUsImage from "../assets/contactUsImage.jpg";
import AOS from "aos";
import "aos/dist/aos.css";

export default function ContactForm() {

    useEffect(() => {
      AOS.init({
        duration: 1000, // animation duration
        once: true,     // animate only once
        disable: 'mobile' // disable on mobile devices
      });
    }, []);

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_naw1v43",
        "template_d7ailb3",
        form.current,
        "l3l3FP_Lpt9hrNzVL"
      )
      .then(
        () => {
          Swal.fire({
            title: "Success!",
            text: "Email sent successfully!",
            icon: "success",
            confirmButtonColor: "#d4af37",
          });
          form.current.reset();
        },
        () => {
          Swal.fire({
            title: "Oops!",
            text: "Failed to send email. Try again.",
            icon: "error",
            confirmButtonColor: "#d4af37",
          });
        }
      );
  };

  return (
    <div className="contact-section" data-aos="zoom-in">
      <div className="contact-left">
        <img src={contactUsImage} alt="Contact" className="contact-image" />
        <h1 className="contact-heading">We’re here to make your day unforgettable</h1>
        <p className="contact-subtext">
          Whether it’s a wedding, engagement, or pre-wedding shoot — let’s capture your moments beautifully.
        </p>
      </div>

      <div className="contact-right">
        <form ref={form} onSubmit={sendEmail} className="contact-form">
          <h2>Contact Us</h2>
          <input type="text" name="name" placeholder="Your Name" required />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea name="message" placeholder="Your Message" required />
          <button type="submit">Send Message</button>
        </form>
      </div>
    </div>
  );
}
